import { useEffect, useState } from "react"

import { Grid, Spinner, SpinnerProps } from "@chakra-ui/react"
import { AnimatePresence, HTMLMotionProps, motion } from "framer-motion"

type DivPropsWithMotion = HTMLMotionProps<"div">

const MotionGrid = motion(Grid)

export const FullScreenOverlay = (props: DivPropsWithMotion) => {
  return (
    <MotionGrid
      position="fixed"
      height="100vh"
      width="100vw"
      top="0"
      left="0"
      placeItems="center"
      background="pageBgColor"
      zIndex="overlay"
      {...props}
    />
  )
}

export const LoadingSpinner = (props: SpinnerProps) => {
  return (
    <Spinner
      thickness="4px"
      speed="0.65s"
      emptyColor="gray.200"
      color="primaryColor"
      size="xl"
      {...props}
    />
  )
}

interface LoadingScreenProps extends HTMLMotionProps<"div"> {
  show: boolean
  /** Minimum time the loading screen stays visible before hiding */
  delay?: number
  spinner?: SpinnerProps
}

export const LoadingScreen = ({
  show,
  delay = 500,
  spinner,
  ...rest
}: LoadingScreenProps) => {
  const [shouldShow, setShouldShow] = useState(show)

  useEffect(() => {
    if (show) {
      setShouldShow(true)
    } else {
      const timer = setTimeout(() => {
        setShouldShow(false)
      }, delay)
      return () => clearTimeout(timer)
    }
  }, [show, delay])

  return (
    <AnimatePresence>
      {shouldShow && (
        <FullScreenOverlay
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          {...rest}
        >
          <LoadingSpinner {...spinner} />
        </FullScreenOverlay>
      )}
    </AnimatePresence>
  )
}
